import React from 'react';

import Box from '../Box/Box';

type TModalContent = {
  children: React.ReactNode;
  className?: string;
};

const ModalContent = ({ children, className }: TModalContent) => (
  <Box as="div" parent="Modal" name="Content" className={className}>
    {children}
  </Box>
);

export default ModalContent;
